import {style, keyframes} from 'typestyle'

export const WKloadMoreWrap = style({
  display: 'block',
  textAlign: 'center',
  lineHeight: '1.6em',
  fontSize: 14,
  position: 'relative',
  paddingBottom: 30,
  bottom: 0,
  width: '100%',
  maxWidth: 480,
  paddingTop: 20
})

const Loading = keyframes({
  '0%' : { transform: 'rotate3d(0, 0, 1, 0deg)' },
  '100%' : { transform: 'rotate3d(0, 0, 1, 360deg)'}
})

export const WKloadMore = style({
    width: 20,
    height: 20,
    display: 'inline-block',
    verticalAlign: 'middle',
    animationName: Loading,
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    background: `rgba(216, 0, 0, 0) url('https://static-cos.lycheer.net/picture/8173011_cb7d85c98815780ec40414520416eed1.jpg') no-repeat`,
    backgroundSize: '100%'
})

export const loadTips = style({
    display: 'inline-block'
})



// WEBPACK FOOTER //
// ./src/components/WKloadMore/WKloadMore.style.ts